import classNames from 'classnames';

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  maxWidth?: string;
}

export const Square = ({
  width = 100,
  height = 100,
  maxWidth = 'max-w-sm',
}: SkeletonProps) => {
  return (
    <div role="status" className={classNames('animate-pulse', maxWidth)}>
      <div
        className={`bg-slate-400 rounded-lg dark:bg-slate-400`}
        style={{
          width: `${width}${typeof width === 'number' ? 'px' : ''}`,
          height: `${height}${typeof height === 'number' ? 'px' : ''}`,
        }}
      ></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};
